module.exports = __webpack_public_path__ + "static/media/Articles 11.1b3778ff.svg";